import { useTeamStore } from "@/app/store/useTeamStore";

/**
 * 인증 토큰과 팀 선택 상태를 모두 초기화한다.
 * 수동 로그아웃, 401 토큰만료 등 세션 종료 시 호출.
 */
export function clearSession() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("google_access_token");
  useTeamStore.persist.clearStorage();
  useTeamStore.setState({ selectedTeam: null, selectedTeamId: null });
}
